import { useEffect, useState } from "react";
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { api, jsonBody } from "../api";
import { PageHeader } from "../components/PageHeader";
import { StatusChip } from "../components/StatusChip";
export function AdministratorsPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const load = () =>
    api<{ administrators: any[] }>("/admin/administrators").then((r) =>
      setRows(r.administrators),
    );
  useEffect(() => {
    void load();
  }, []);
  return (
    <>
      <PageHeader
        title="Administrators"
        subtitle="Cloudflare Access identities and application roles."
        actions={
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setOpen(true)}
          >
            Add administrator
          </Button>
        }
      />
      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Last login</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.email}>
                <TableCell>{r.email}</TableCell>
                <TableCell>{r.display_name}</TableCell>
                <TableCell>{r.role}</TableCell>
                <TableCell>
                  <StatusChip value={r.status} />
                </TableCell>
                <TableCell>
                  {r.last_login_at
                    ? new Date(r.last_login_at).toLocaleString()
                    : "—"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
      <AdminDialog
        open={open}
        onClose={() => setOpen(false)}
        onSaved={() => {
          setOpen(false);
          void load();
        }}
      />
    </>
  );
}
function AdminDialog({
  open,
  onClose,
  onSaved,
}: {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
}) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState("VIEWER");
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add or update administrator</DialogTitle>
      <DialogContent>
        <Stack gap={2} mt={1} minWidth={380}>
          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Display name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            select
            label="Role"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            {["SUPER_ADMIN", "ADMIN", "SUPPORT", "VIEWER"].map((r) => (
              <MenuItem key={r} value={r}>
                {r}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!email}
          onClick={async () => {
            await api(`/admin/administrators/${encodeURIComponent(email)}`, {
              method: "PUT",
              body: jsonBody({ role, status: "ACTIVE", displayName: name }),
            });
            onSaved();
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
